module.exports = __webpack_public_path__ + "static/media/tti_promotion_title@2x.c74d9846.png";